import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ContatoService } from 'src/app/shared/services/contato.service';
import { showFeedbackSuccess } from 'src/app/shared/util/alert-swal';
import { AnalyticsService } from 'src/app/shared/util/analytics.service';
import { SeoService } from 'src/app/shared/util/seo.service';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { PAGE_TITLE, checkPhoneSintax } from 'src/globals';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  fmGroup: UntypedFormGroup;
  ufs = [
    'RS',
    'SP',
    'SC',
    'PR',
    'RJ',
    'MG',
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'RN',
    'RO',
    'RR',
    'SE',
    'TO',
  ];
  subjects = ['Compra de imóvel', 'Aluguel de imóvel', 'Venda de imóvel'];

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private contatoService: ContatoService,
    private seo: SeoService,
    private ga: AnalyticsService
  ) {
    const canal = this.route.snapshot.paramMap.get('channel');
    if (canal == 'venda') this.createForm(this.subjects[2]);
    else if (canal == 'alugue') this.createForm(this.subjects[1]);
    else this.createForm(this.subjects[0]);
  }

  createForm(subject: string) {
    this.fmGroup = this.formBuilder.group({
      name: [null, Validators.required],
      phone: [
        null,
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(15),
        Validators.compose([checkPhoneSintax]),
      ],
      email: [null, Validators.required, Validators.email],
      city: [null, Validators.required],
      uf: [this.ufs[0]],
      subject: [subject],
      message: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Contato - ${PAGE_TITLE}`);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo
      .addTitle(this.titleService.getTitle())
      .addDescription(
        `Para dúvidas e informações entre em contato conosco. Temos uma equipe especializada para melhor atendê-los | Private Imóveis`
      );
  }

  onSend() {
    // Valida os campos do form
    if (this.fmGroup.invalid) return;

    const { name, phone, email, city, uf, subject, message } = this.fmGroup.value;
    this.contatoService.envia(name, phone, email, city, uf, subject, message).subscribe(
      result => {
        this.fmGroup.reset(); // limpa os campos do form
        this.ga.trackEvent('contact', 'form', 'website');
        showFeedbackSuccess('Sua mensagem foi enviada!', 'Em breve um de nossos consultores entrará em contato.');
      },
      error => {
        SessionManager.handleHttpError(error, 'Falha ao enviar o contato');
      }
    );
  }

  onMapOpen(location: string) {
    this.ga.trackEvent('map', 'contact', location);
  }
}
